import React from "react";
import { cn } from "@/lib/utils";

export const FeedTabs = ({ tabs, active, onChange, className = "" }) => (
  <div className={cn("no-scrollbar flex gap-1 overflow-x-auto", className)} role="tablist">
    {tabs.map((t) => (
      <button
        key={t}
        role="tab"
        aria-selected={active === t}
        onClick={() => onChange(t)}
        data-testid={`feed-tab-${t.toLowerCase().replace(/\s+/g, "-")}`}
        className={cn(
          "relative shrink-0 rounded-full px-4 py-2 text-sm font-semibold transition-colors",
          active === t ? "text-[#050814]" : "text-slate-400 hover:text-white"
        )}
      >
        {active === t && (
          <span className="absolute inset-0 -z-10 rounded-full bg-cyan-400" />
        )}
        {t}
      </button>
    ))}
  </div>
);

export default FeedTabs;
